export const loteFabricacaoSearch = {
  label: 'Lote de Fabricação',
  placeholder: 'ID ou Nº Lote...',
  titulo: 'Buscar Lote de Fabricação',
  endpointApi: 'LotesFabricacao',
  idField: 'idLoteFabricacao',
  displayField: 'idLoteFabricacao',
  descField: 'numeroLoteFornecedor',
  camposFiltro: [
    { label: 'Busca Livre', model: 'buscaLivre', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idLoteFabricacao', width: '10%' },
    { header: 'Nº Lote Fornecedor', dataField: 'numeroLoteFornecedor', width: '25%' },
    { header: 'Produto', dataField: 'nomeProduto', width: '25%' },
    { header: 'Fornecedor', dataField: 'nomeFornecedor', width: '25%' },
    { header: 'Data Fabricação', dataField: 'dataFabricacao', width: '15%' }
  ]
}
